import React from "react";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";
import NestedTabsComponent from "../nested-tabs-component";
import { SPLIT_TEST_TABS, NESTED_SIDENAV, ACCESS_CONFIG } from "../strings";

// Split tests on the funnel order form (Asana 1219217770567617):
// one sub-tab per funnel type, each with its own running test.
const SplitTests = () => {
  const { t } = useTranslation();
  const { MARKETING_MANAGER_TIER } = ACCESS_CONFIG;
  return (
    <div className="d-flex h-100">
      <div className="sub-sidebar">
        <div className="inner-sub-sidebar">
          <div className="tab-heading ps-3 mt-4">{t("splitTests.title")}</div>
          <NestedTabsComponent
            nestedNavType={NESTED_SIDENAV.SPLIT_TESTS}
            tabs={[
              {
                evKey: SPLIT_TEST_TABS.LEAD,
                title: t("splitTests.tabs.lead"),
                access: MARKETING_MANAGER_TIER
              },
              {
                evKey: SPLIT_TEST_TABS.EMPLOYEE,
                title: t("splitTests.tabs.employee"),
                access: MARKETING_MANAGER_TIER
              }
            ]}
          />
        </div>
      </div>
      <div className="outlet-wrapper">
        <Outlet />
      </div>
    </div>
  );
};
export default SplitTests;
